import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTWCL_Verifying_your_payment_method__ELL } from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <Translation {...TXTWCL_Verifying_your_payment_method__ELL} />
);

export default HelpSectionContent;
